import React, { createContext } from 'react';


  const TabContext = createContext(0);

  export default TabContext
